import React, { Component, PropTypes } from 'react';
import Select from 'react-select';

export default class SubscriptionsList extends Component {

    render() {
        let { subscriptions, subscription } = this.props;

        let options = subscriptions.map(function (subscription) {
            let description = subscription.number ? subscription.number + ' - ' + subscription.subscriptionName : subscription.subscriptionName;

            return { label: description, value: subscription.id }
        });
        let currentSubscription = options.find(function (option){
            return option.value === subscription.id;
        });

        return (
            <div className="mp-subscription-list">
               <Select options={options} value={currentSubscription} clearable={false} autoBlur={true} onChange={this.getSubscriptionInfo} />
            </div>
        );
    }

    getSubscriptionInfo = ({ value }) => {
       this.props.subscriptionSelected(value);
    }
}

SubscriptionsList.propTypes = {
    subscription: PropTypes.object.isRequired,
    subscriptions: PropTypes.array.isRequired,
    subscriptionSelected: PropTypes.func.isRequired
};